import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Pagination } from '../../Pagination';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListBottomBar(props) {
  const {
    paginationMetaData,
    bottomBarLeftSlot,
    showMargin
  } = props;
  const {
    isMobile
  } = useIsMobile(640);
  const listTopBarClasses = classNames({
    [moduleStyles['sib-list__bottombar']]: true,
    [moduleStyles['sib-list__bottombar-xs']]: isMobile
  });
  return /*#__PURE__*/React.createElement("div", {
    className: listTopBarClasses,
    style: showMargin ? {
      marginBottom: '96px'
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__bottombar-slot']
  }, bottomBarLeftSlot), paginationMetaData && /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__pagination']
  }, /*#__PURE__*/React.createElement(Pagination, paginationMetaData)));
}
ListBottomBar.defaultProps = {
  paginationMetaData: null,
  showMargin: false,
  bottomBarLeftSlot: /*#__PURE__*/React.createElement(React.Fragment, null)
};
ListBottomBar.propTypes = {
  paginationMetaData: PropTypes.object,
  bottomBarLeftSlot: PropTypes.node,
  showMargin: PropTypes.bool
};
export default ListBottomBar;